var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.width },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var onDialog = ref.on
            return [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var onTooltip = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass: "my-0",
                                  attrs: {
                                    color: "primary",
                                    icon: "",
                                    small: "",
                                    disabled: _vm.disabled,
                                  },
                                },
                                onDialog
                              ),
                              [
                                _c("v-icon", _vm._g({}, onTooltip), [
                                  _vm._v(_vm._s(_vm.icon)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                },
                [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _vm._t("toolbar", function () {
            return [
              _c(
                "v-toolbar",
                {
                  attrs: { color: "secondary", tabs: "", dark: "", flat: "" },
                  scopedSlots: _vm._u(
                    [
                      Array.isArray(_vm.body)
                        ? {
                            key: "extension",
                            fn: function () {
                              return [
                                _c(
                                  "v-tabs",
                                  {
                                    attrs: { color: "secondary", grow: "" },
                                    model: {
                                      value: _vm.tabRef,
                                      callback: function ($$v) {
                                        _vm.tabRef = $$v
                                      },
                                      expression: "tabRef",
                                    },
                                  },
                                  [
                                    _c("v-tabs-slider", {
                                      attrs: { color: "accent" },
                                    }),
                                    _vm._l(_vm.body, function (bod) {
                                      return _c("v-tab", { key: bod.title }, [
                                        _vm._v(_vm._s(bod.title)),
                                      ])
                                    }),
                                  ],
                                  2
                                ),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm.title
                    ? _c("v-toolbar-title", [
                        _vm._v(" " + _vm._s(_vm.title) + " "),
                      ])
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { icon: "" }, on: { click: _vm.closeDialog } },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-progress-linear", {
                    attrs: {
                      active: _vm.loading,
                      indeterminate: _vm.loading,
                      absolute: "",
                      bottom: "",
                      color: "primary",
                    },
                  }),
                ],
                1
              ),
            ]
          }),
          Array.isArray(_vm.body)
            ? _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tabRef,
                    callback: function ($$v) {
                      _vm.tabRef = $$v
                    },
                    expression: "tabRef",
                  },
                },
                _vm._l(_vm.body, function (bod) {
                  return _c(
                    "v-tab-item",
                    { key: bod.title },
                    [
                      _c(
                        "keep-alive",
                        [
                          _c(
                            bod.component,
                            _vm._b(
                              { tag: "component" },
                              "component",
                              bod.props,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _c(
                "keep-alive",
                [
                  _c(
                    _vm.body.component,
                    _vm._g(
                      _vm._b(
                        {
                          key: _vm.body.key ? _vm.body.key : 0,
                          tag: "component",
                          attrs: { isDialogOpen: _vm.showDialog },
                          on: { "close-dialog": _vm.closeDialog },
                        },
                        "component",
                        _vm.body.props,
                        false
                      ),
                      _vm.$listeners
                    )
                  ),
                ],
                1
              ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }